import { render, staticRenderFns } from "./InputPHSelect.vue?vue&type=template&id=ffb0c212&"
import script from "./InputPHSelect.vue?vue&type=script&lang=js&"
export * from "./InputPHSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports